// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2n95K","footer":"ChangeClinic_footer__3scH5"};